import React, { Dispatch, ReactNode, SetStateAction, createContext, useContext } from "react";

import { AnswerContextManager } from "hooks/useAnswerContextManager";
import { AnsweredEntity } from "types/entities";

export type AnswerContextValue<T extends AnsweredEntity = AnsweredEntity> =
  AnswerContextManager<T> & {
    readOnly: boolean;
    nextAction?: any;
    setNextAction: Dispatch<SetStateAction<any>>;
    context?: any;
    reload?: () => void;
    reset?: () => void;
    onCreate?: () => Promise<void>;
  };

const AnswerContext = createContext<AnswerContextValue | undefined>(undefined);

interface AnswerContextProviderProps {
  value: AnswerContextValue;
  children: ReactNode;
}

const AnswerContextProvider: React.FC<AnswerContextProviderProps> = ({ value, children }) => (
  <AnswerContext.Provider value={value}>{children}</AnswerContext.Provider>
);

export const useAnswerContext = (): AnswerContextValue => useContext(AnswerContext);

export default AnswerContextProvider;
